
import React, { useState, useEffect } from "react";
import * as sweetalert from "sweetalert";
import axios from "axios";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import { FormControl, Grid, InputLabel } from "@material-ui/core";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
import packageJson from "../../../../package.json";
import { TextareaAutosize } from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function AddNotifcation() {
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [discount_fatora_bank, setDiscount_fatora_bank] = useState([]);
  const [increase_sell_percent, setIncrease_sell_percent] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [Banks, setBanks] = useState([]);
  const [loadingFatora, setLoadingFatora] = useState(false);
  const navigate = useNavigate();
  // useEffect(() => {
  //   setIsLoading(true);
  //   getEPaymentConfig()
  //     .then((res) => {
  //       setGetPaymentconfigration(res);

  //       setIsLoading(true);
  //     })
  //     .catch((err) => {
  //       setGetPaymentconfigration([]);
  //       setIsLoading(false);
  //     });
  //   getAllBanks().then((res) => {
  //     setBanks(res);
  //   });
  //   getAllPaymentMethods()
  //     .then((res) => {
  //       setPaymentMethod(res.data);
  //       setIsLoading(true);
  //     })
  //     .catch((err) => {
  //       setGetPaymentconfigration([]);
  //       setIsLoading(false);
  //     });

  //   return () => {};
  // }, []);

  const initialFValues = {
    title: "",
    body: "",

  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };


    if ("title" in fieldValues)
      temp.title = fieldValues.title ? "" : "الحقل مطلوب";
    if ("body" in fieldValues)
      temp.body = fieldValues.body ? "" : "الحقل مطلوب";

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };

  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setLoadingFatora(true);
     const data ={
       title: loginInput.title,
       body :loginInput.body
      }
    
      axios
        .post(`${BaseUrl}/api/addNotification`, data, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoadingFatora(false);

            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then((res) => {
              // window.location.reload();
              navigate('/notifcation');
            });
          } else {
            setLoadingFatora(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
        });
    }else{

    }
  };
  const handleChange = (e, fieldName) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value)) {
      if (fieldName === "amount") {
        const discount =
          value - Paymentconfigration.discount_fatora_bank * value;
        const sell = value + Paymentconfigration.increase_sell_percent * value;
        setDiscount_fatora_bank(discount);
        setIncrease_sell_percent(sell);
        setLogin({ ...loginInput, amount: value });
      }
    } else {
      console.error("Invalid number entered");
    }
  };

  return (
    <div className="main-div">
      <h3 className="titlepage">إشعار جديد</h3>
      <Form className="form-group new-design" onSubmit={handleSubmit}>
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={12} xs={12}>
            <Controls.Input
              label="عنوان الاشعار"
              name="title"
              variant="outlined"
              fullWidth
              onChange={handleInputChange}
              className="form-control"
              type="text"
            />
          </Grid>
          <Grid item md={12} xs={12}>
          <FormControl fullWidth >
            <InputLabel htmlFor="textarea-label" className="title-notifcation">وصف الاشعار</InputLabel>
            <TextareaAutosize
            className="box-textarea"
              id="textarea-label"
              aria-label="empty textarea"
              name='body'
              onChange={handleInputChange}
              minRows={12}
              style={{ width: "100%" }}
            />
          </FormControl>

          </Grid>
        </Grid>

        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loadingFatora === true ? (
            <Controls.Button
              type="submit"
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <Controls.Button
              type="submit"
              text={"إرسال"}
              onClick={handleSubmit}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          )}
        </Grid>
      </Form>
    </div>
  );
}
